import { RouteItem } from '@eastcoal/router/types/route'

import {
  PRICING_CREATE_PAGE_PATH,
  PRICING_DETAIL_PAGE_PATH,
  PRICING_EDIT_PAGE_PATH,
  PRICING_LIST_PAGE_PATH
} from './constants/path'
import { PRICING_PAGE_UUID } from './constants/uuid'

export const pricingRoute: RouteItem = {
  title: '计价方式',
  uuid: PRICING_PAGE_UUID,
  hideChildrenInMenu: true,
  children: [
    {
      title: '计价方式列表',
      path: PRICING_LIST_PAGE_PATH,
      Component: () => import('./List/index')
    },
    {
      title: '新增计价方式',
      path: PRICING_CREATE_PAGE_PATH,
      Component: () => import('./Create')
    },
    {
      title: '编辑计价方式',
      path: PRICING_EDIT_PAGE_PATH,
      Component: () => import('./Edit')
    },
    {
      title: '计价方式详情',
      path: PRICING_DETAIL_PAGE_PATH,
      Component: () => import('./Detail')
    }
  ]
}
